export default __webpack_public_path__ + "static/media/flipHand.9167d209.png";